import axiosInstance from "./axiosInstance";

/** Finkeda Terminal Load — create checkout and redirect */
export const AddmoneyCreditCard = async (p) => {
  try {
    const payload = {
      ...p,
      idempotencyKey:
        p.idempotencyKey ||
        `am_${p.amount}_${p.mobile}_${Date.now()}`.slice(0, 64),
    };
    const response = await axiosInstance.post(
      `/api/addmoney/card-to-addmoney`,
      payload
    );
    return {
      success: true,
      data: response?.data,
      message: response?.data?.message || "Checkout created",
      redirectionUrl:
        response?.data?.redirectionUrl ||
        response?.data?.redirectUrl ||
        response?.data?.order?.redirectionUrl ||
        response?.data?.data?.redirectionUrl,
      kycUrl:
        response?.data?.kycUrl ||
        response?.data?.data?.kycUrl ||
        response?.data?.order?.kycUrl ||
        null,
      requiresKyc: Boolean(
        response?.data?.requiresKyc || response?.data?.data?.requiresKyc
      ),
      urn: response?.data?.urn || response?.data?.data?.urn,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Checkout failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const fetchFinkedaGateways = async () => {
  try {
    const response = await axiosInstance.get(`/api/finkeda/gateways`);
    return {
      success: true,
      data: response?.data?.data || response?.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to load gateways",
    };
  }
};

export const checkFinkedaStatus = async (orderId) => {
  try {
    const response = await axiosInstance.post(`/api/finkeda/status`, { orderId });
    return {
      success: true,
      data: response?.data?.data || response?.data,
      message: response?.data?.message,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Status check failed",
    };
  }
};

export const TransferAddMoneyToMainWallet = async (amount) => {
  try {
    const response = await axiosInstance.post(`/api/addmoney/transfer/addmoney-to-main`, amount);
    return {
      success:response.data.success ||  true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchAddmoneyTrancation= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/addmoney/transaction`,{
        params:params
    });
    return {
       success:response.data.success ||  true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
